<div class="container bg-white">
	<div class="row inside">
		<div class="w-100">			
			<p>&nbsp;</p>
			<span class="h5">Connect your account to receive payments</span>
			<p>&nbsp;</p>
			<p class="ml-4"><a *ngIf="!stripeId" href="https://connect.stripe.com/oauth/authorize?response_type=code&client_id=ca_DiNlS8yp9rs0GHV1fOIzcLGBLu4KfUYl&scope=read_write"><img src="assets/img/ui/blue-on-light.png"></a></p>
			<p>&nbsp;</p>
            <p>&nbsp;</p>
            <p>&nbsp;</p>
            <p>&nbsp;</p>
		<div *ngIf="stripeId" class="card w-100 mt-4 mr-4 ml-4"> <!-- init card -->
          <div class="card-header">
            Account details
          </div>
          <div class="card-body">
            <h5 class="card-title">Transforma Connect account</h5>
            <p class="card-text">Current stripe ID {{stripeId}}</p>
            <p class="card-text">Current plans:<br>Montly payment of $125</p>
            <div class="d-flex justify-content-end"></div>
           
		</div>
			 <p>&nbsp;</p>
            <p>&nbsp;</p>
            <p>&nbsp;</p>
            <p>&nbsp;</p>
            <p>&nbsp;</p>
            <p>&nbsp;</p>
            <p>&nbsp;</p>
            <p>&nbsp;</p>
            <p>&nbsp;</p>
            <p>&nbsp;</p>
          </div>
	</div>
</div>